import { loadMixtape } from 'store/playerSlice';

export const MIX_BASE = 'https://assets.intrepidpixel.org/mixtape';

export const fetchTapes = () =>
  fetch(`${MIX_BASE}/manifest.json`).then((r) => r.json());

// Resolve a mixtape id from the archive and load it into the shared player.
// Returns the loaded mixtape, or null if no tape matches the id.
export const loadMixById = (dispatch, id, { crossfade = false } = {}) =>
  fetchTapes().then((tapes) => {
    const tape = tapes.find((t) => t.id === id || Number(t.id) === Number(id));
    if (!tape) return null;
    return fetch(`${MIX_BASE}/${tape.id}/manifest.json`)
      .then((r) => r.json())
      .then((album) => {
        const mixtape = {
          id: tape.id,
          title: album.title || tape.title,
          artist: album.artist || tape.artist,
          src: `${MIX_BASE}/${tape.id}/${album.audioFile}`,
          tracks: album.tracks || []
        };
        dispatch(loadMixtape({ ...mixtape, crossfade }));
        return mixtape;
      });
  });
